import {
  WorkflowPartnerOneUpgradeCuComponent
} from "./workflow-partner-one-upgrade-cu/workflow-partner-one-upgrade-cu.component";
import {
  WorkflowPartnerOneUpgradeSlaComponent
} from "./workflow-partner-one-upgrade-sla/workflow-partner-one-upgrade-sla.component";
import {
  WorkflowPartnerOneDowngradeCuComponent
} from "./workflow-partner-one-downgrade-cu/workflow-partner-one-downgrade-cu.component";
import {
  WorkflowPartnerOneDowngradeSlaComponent
} from "./workflow-partner-one-downgrade-sla/workflow-partner-one-downgrade-sla.component";
import {WorkflowPartnerService} from "./workflow-partner.service";
import {
  WorkflowPartnerOneTrialCreateComponent
} from "./workflow-partner-one-trial-create/workflow-partner-one-trial-create.component";

import {
  WorkflowPartnerAddTrialPhonenumberComponent
} from "./workflow-partner-add-trial-phonenumber/workflow-partner-add-trial-phonenumber.component"
import { WorkflowPartnerOneAvailabilityOrderCancelComponent } from "./workflow-partner-one-availability-order-cancel/workflow-partner-one-availability-order-cancel.component";
import { WorkflowPartnerOneAvailabilityComponent } from "./workflow-partner-one-availability/workflow-partner-one-availability.component";
import { WorkflowPartnerOneTariffComponent } from "./workflow-partner-one-tariff/workflow-partner-one-tariff.component"
import { WorkflowPartnerOneTariffOrderCancelComponent } from "./workflow-partner-one-tariff-order-cancel/workflow-partner-one-tariff-order-cancel.component";
import { WorkflowPartnerOneCancelPhonenumberComponent } from "./workflow-partner-one-cancel-phonenumber/workflow-partner-one-cancel-phonenumber.component";
import { WorkflowPartnerAiTariffComponent } from "./workflow-partner-ai-tariff/workflow-partner-ai-tariff.component";
import { WorkflowPartnerAiTariffOrderCancelComponent } from "./workflow-partner-ai-tariff-order-cancel/workflow-partner-ai-tariff-order-cancel.component";

export const workflowPartnerComponents= [
  WorkflowPartnerOneUpgradeCuComponent,
  WorkflowPartnerOneUpgradeSlaComponent,
  WorkflowPartnerOneDowngradeCuComponent,
  WorkflowPartnerOneDowngradeSlaComponent,
  WorkflowPartnerOneTrialCreateComponent,
  WorkflowPartnerAddTrialPhonenumberComponent,
  WorkflowPartnerOneAvailabilityOrderCancelComponent,
  WorkflowPartnerOneAvailabilityComponent,
  WorkflowPartnerOneTariffComponent,
  WorkflowPartnerOneTariffOrderCancelComponent,
  WorkflowPartnerOneCancelPhonenumberComponent,
  WorkflowPartnerAiTariffComponent,
  WorkflowPartnerAiTariffOrderCancelComponent,
]

export const workflowPartnerServices = [
  WorkflowPartnerService,
]
